import React, { useState } from 'react';
import "../importarcontadores.css";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Button, Input, Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

toast.configure();

function Importarcontador() {
  const [registar, setRegistro] = useState({ nrcontador: "" });
  const [rg, setRg] = useState(null);
  const [imp, setImp] = useState(null);
  const [error, setError] = useState();
  const [state, setState] = useState();

  const handleRegis = () => {
    setRg("sdsd");
    setImp(null);
  }

  const handleImport = () => {
    setRg(null);
    setImp("sdsd");
  }

  const handleFile = (file) => {
    setState({ File: file });
  }

  const uploadFile = () => {
    const formData = new FormData();
    formData.append('media', state.File);

    axios({
      method: "post",
      url: `${localStorage.getItem('url')}/web/importarcontador/`,
      headers: { 'Authorization': `token ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' },
      data: formData
    }).then(dat => {
      if (dat.status !== 200) {
        throw Error('Dados de acesso inválidos');
      }
      toast.success("Contadores importados com sucesso!");
    }).catch(e => {
      toast.error("O contador já foi registrado!");
    });
  }

  const registrar = () => {
    axios({
      method: "post",
      url: `${localStorage.getItem('url')}/web/registarcontador/`,
      headers: { 'Authorization': `token ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' },
      data: registar
    }).then(dat => {
      if (dat.status !== 200) {
        throw Error('Dados de acesso inválidos');
      }
      toast.success("Contador registrado com sucesso!");
    }).catch(e => {
      console.log(e);
      toast.error("O contador já foi registrado ou o número de contador é inválido!");
    });
  }

  return (
    <div className='importar'>
      <Button  onClick={handleRegis}>Registrar contador</Button>
      <Button onClick={handleImport}>Importar Contadores</Button>

      {rg && 
        <div className='registarmeter'>
          <div>Numero do Contador</div>
          <Input type="text" id="ipesqui" name="name" autoComplete='off' maxLength={13} value={registar.nrcontador} onChange={e => setRegistro({ ...registar, nrcontador: e.target.value })} required />
          <Button  onClick={registrar}>Registrar</Button>
        </div>
      }

      {imp && 
        <div className='importarClientes'>
          <Upload onChange={(info) => handleFile(info.file)}>
            <Button icon={<UploadOutlined />}>Selecionar Arquivo</Button>
          </Upload>
          <Button onClick={uploadFile}>Importar</Button>
        </div>
      }
    </div>
  );
}

export default Importarcontador;
